import { type Mode, type NumericFormat } from './NumberInput.types';

type ModeProps = {
  [M in Mode]: NumericFormat;
};

const DEFAULT_MODE_PROPS = {
  decimalScale: 2,
  decimalSeparator: ',',
  thousandSeparator: '.',
  valueIsNumericString: true,
} satisfies NumericFormat;

const MODES = {
  CURRENCY: 'currency',
  DEFAULT: 'default',
  INTEGER: 'int',
} as const;

const MODE_PROPS = {
  [MODES.CURRENCY]: {
    allowNegative: false,
    fixedDecimalScale: true,
    prefix: '€',
  },
  [MODES.DEFAULT]: {},
  [MODES.INTEGER]: {
    decimalScale: 0,
    thousandSeparator: false,
  },
} satisfies ModeProps;

export { DEFAULT_MODE_PROPS, MODE_PROPS, MODES };
